/**
 * Date display format from account settings (localStorage).
 * Values: 'dd.mm.yyyy' | 'mm/dd/yyyy' | 'yyyy-mm-dd'
 */
export const getDateFormat = () => {
  return typeof localStorage !== 'undefined' ? (localStorage.getItem('dateFormat') || 'dd.mm.yyyy') : 'dd.mm.yyyy';
};

/**
 * Format a Date for display in the account's chosen format.
 * @param {Date} date
 * @param {string} [format] - optional override (default: from localStorage)
 * @returns {string}
 */
export const formatDateForDisplay = (date, format) => {
  if (!date || !(date instanceof Date) || isNaN(date.getTime())) return '';
  const f = format || getDateFormat();
  const d = String(date.getDate()).padStart(2, '0');
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const y = date.getFullYear();
  if (f === 'dd.mm.yyyy') return `${d}.${m}.${y}`;
  if (f === 'mm/dd/yyyy') return `${m}/${d}/${y}`;
  if (f === 'yyyy-mm-dd') return `${y}-${m}-${d}`;
  return `${d}.${m}.${y}`;
};

/**
 * Parse a date string in the account's chosen format to a Date (local date, no TZ shift).
 * @param {string} str
 * @param {string} [format] - optional override
 * @returns {Date|null}
 */
export const parseDateFromDisplay = (str, format) => {
  if (!str || typeof str !== 'string') return null;
  const trimmed = str.trim();
  if (!trimmed) return null;
  const f = format || getDateFormat();
  let day, month, year;
  if (f === 'dd.mm.yyyy') {
    const parts = trimmed.split(/[./-]/);
    if (parts.length !== 3) return null;
    day = parseInt(parts[0], 10);
    month = parseInt(parts[1], 10) - 1;
    year = parseInt(parts[2], 10);
  } else if (f === 'mm/dd/yyyy') {
    const parts = trimmed.split(/[/.-]/);
    if (parts.length !== 3) return null;
    month = parseInt(parts[0], 10) - 1;
    day = parseInt(parts[1], 10);
    year = parseInt(parts[2], 10);
  } else if (f === 'yyyy-mm-dd') {
    const parts = trimmed.split(/[-./]/);
    if (parts.length !== 3) return null;
    year = parseInt(parts[0], 10);
    month = parseInt(parts[1], 10) - 1;
    day = parseInt(parts[2], 10);
  } else {
    const parts = trimmed.split(/[./-]/);
    if (parts.length !== 3) return null;
    day = parseInt(parts[0], 10);
    month = parseInt(parts[1], 10) - 1;
    year = parseInt(parts[2], 10);
  }
  if (isNaN(day) || isNaN(month) || isNaN(year)) return null;
  const date = new Date(year, month, day);
  if (date.getFullYear() !== year || date.getMonth() !== month || date.getDate() !== day) return null;
  return date;
};
